import {Component, inject, input, InputSignal, output, OutputEmitterRef, signal, ViewEncapsulation, WritableSignal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxListModule, DxTextBoxModule} from 'devextreme-angular';
import {SharedModule} from '../../../../../shared/shared.module';
import {PointDeLivraisonDTO} from '../../../../../core/dtos/point-de-livraison-d-t-o';
import {ContratMenuConviveDTO} from '../../../../../core/dtos/contratmenuconvive-dto';
import {PointDeLivraisonService} from '../../../../../core/services/entities/point-de-livraison.service';
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';
import {cloneDeep as _cloneDeep, find as _find} from 'lodash';
import {DialogAjoutPlcComponent} from "./dialog-ajout-plc/dialog-ajout-plc.component";
import {DialogDeletePlcComponent} from "./dialog-delete-plc/dialog-delete-plc.component";

@Component({
  selector: 'yo-plc-list',
  templateUrl: './plc-list.component.html',
  styleUrls: ['./plc-list.component.scss'],
  standalone: true,
  imports: [CommonModule, DxListModule, DxTextBoxModule, SharedModule, DialogAjoutPlcComponent, DialogDeletePlcComponent],
  encapsulation: ViewEncapsulation.None
})
export class PlcListComponent {

  plcList: InputSignal<PointDeLivraisonDTO[]> = input<PointDeLivraisonDTO[]>([]);
  selectedPlcId: InputSignal<number | undefined> = input<number>();
  contratMenuConvive: InputSignal<ContratMenuConviveDTO | undefined> = input<ContratMenuConviveDTO>();
  title: InputSignal<string> = input<string>('');

  onPlcChange: OutputEmitterRef<PointDeLivraisonDTO> = output<PointDeLivraisonDTO>();
  onPlcListChange: OutputEmitterRef<PointDeLivraisonDTO[]> = output<PointDeLivraisonDTO[]>();

  readonly ButtonThemeEnum = ButtonThemeEnum;

  #pdlSvc = inject(PointDeLivraisonService);

  searchValue: WritableSignal<string> = signal<string>('');
  displayAddDialog: WritableSignal<boolean> = signal<boolean>(false);
  displayRemoveDialog: WritableSignal<boolean> = signal<boolean>(false);
  plcToAddList: WritableSignal<PointDeLivraisonDTO[]> = signal<PointDeLivraisonDTO[]>([]);
  plcToRemoveList: WritableSignal<PointDeLivraisonDTO[]> = signal<PointDeLivraisonDTO[]>([]);

  onSearchChanged(event): void {
    this.searchValue.set(event.value || '');
  }

  onSelectionChanged(event: {addedItems: PointDeLivraisonDTO[]}): void {
    const plc = event.addedItems?.[0];
    if (plc) {
      this.onPlcChange.emit(plc);
    }
  }

  openAddDialog(): void {
    this.displayAddDialog.set(true);
    this.#loadPlcToAdd();
  }

  #loadPlcToAdd(): void {
    this.#pdlSvc.getPlcList().subscribe(response => {
      const allPlc = response.resultList || [];
      const currentList = this.plcList();
      const toAdd = allPlc
        .filter(plc => !_find(currentList, {'id': plc.id}))
        .sort((a, b) => a.libelle.localeCompare(b.libelle));
      this.plcToAddList.set(_cloneDeep(toAdd));
    });
  }

  openRemoveDialog(): void {
    this.displayRemoveDialog.set(true);
    this.plcToRemoveList.set(_cloneDeep(this.plcList()));
  }
}
